/* eslint-disable arrow-body-style */
import { Document, Image, Page, StyleSheet, Text, View, Font } from '@react-pdf/renderer';
import React, { memo } from 'react';
import logo from 'assets/images/managemed-logo-2.png';
import prodLogo from 'assets/images/hospitalprivado.png';
import { format, isValid } from 'date-fns';
import { clinicalTreatment, diagnosis, laboratoryExams, radiologicalExams, surgicalTreatment, vitalSigns } from './constants';
// import { Font } from '@react-pdf/renderer'

Font.register({ family: 'Roboto', src: 'assets/fonts/roboto/Roboto-Bold.ttf' });

const styles = StyleSheet.create({
  name: {
    marginLeft: 40,
    fontSize: 24,
  },
  medRecordTitle: {
    fontSize: 16,
    marginLeft: 40,
    marginTop: 20,
    marginBottom: 10,
  },
  logo: {
    width: 200,
    marginLeft: 40,
    marginTop: 40,
    marginBottom: 40,
  },
  tableRow: {
    borderBottomWidth: 1,
    borderBottomColor: 'grey',
    display: 'flex',
    flexDirection: 'row',
  },
  tableCell: {
    borderRightColor: 'grey',
    borderRightWidth: 1,
    minHeight: 25,
    width: 166.6666,
    padding: 5,
  },
  tableCellText: {
    fontSize: 12,
  },
  table: {
    borderTopColor: 'grey',
    borderLeftColor: 'grey',
    borderTopWidth: 1,
    borderLeftWidth: 1,
    marginLeft: 40,
    width: 500,
  },
  emptyState: {
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: 12,
  },

  sectionTitle: {
    fontSize: 18,
    marginBottom: 15,
    marginTop: 15,
    marginLeft: 40,
    fontWeight: 500,
  },
  block: {
    // borderWidth: 1,
    // borderColor: 'grey',
    marginLeft: 40,
    marginTop: 15,
    marginBottom: 15,
    padding: 5,
    width: 500,

    // padding: 5,
  },

  blockTitle: {
    fontSize: 18,
    marginLeft: 40,
    marginBottom: 0,
    marginTop: 15,
    fontWeight: 500,
  },
  blockItem: {
    // padding: 5,
    // marginBottom: 1,
    // marginBottom: 15,
    // display: 'flex',
    // flexDirection: 'row',
    marginBottom: 12,
  },
  blockItemText: {
    fontSize: 12,
  },
  blockItemTitleText: {
    fontSize: 14,
    fontFamily: 'Roboto',
    letterSpacing: 0.5,
    // fontWeight: 700,
  },
  comment: {
    marginLeft: 40,
    borderColor: 'grey',
    borderWidth: 1,
    borderRadius: 5,
    width: 500,
    padding: 10,
    marginBottom: 15,
  },
  page: {
    padding: 20,
  },
  smallCommentText: {
    fontSize: 10,
  },
  commentText: {
    fontSize: 12,
  },

  signField: {
    borderBottomWidth: 1,
    borderBottomColor: 'black',
    width: 100,
    position: 'absolute',
    bottom: 40,
    left: 40,
  },
  signText: { position: 'absolute', bottom: 25, left: 40, fontSize: 8 },
});

const columns = [
  { name: 'codigo', translationKey: 'Codigo' },
  { name: 'descripcion', translationKey: 'Descripcion' },
  { name: 'amount', translationKey: 'Cantidad' },
];

const EmptySkusState = () => (
  <View style={styles.emptyState}>
    <Text>No se han agregado skus</Text>
  </View>
);

const SkuSubcategoryTable = ({ catalog, title }) => {
  return (
    <View>
      <Text style={styles.sectionTitle}>{title}</Text>
      {catalog.length ? (
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {columns.map((field) => (
              <View style={styles.tableCell} key={field.name}>
                <Text style={styles.tableCellText}>{field.translationKey}</Text>
              </View>
            ))}
          </View>
          {catalog.map((row) => (
            <View style={styles.tableRow} key={row._id}>
              {columns.map(({ name }) => (
                <View style={styles.tableCell} key={name}>
                  <Text style={styles.tableCellText}>{row[name]}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      ) : (
        <EmptySkusState />
      )}
    </View>
  );
};

const SkuTable = ({ catalogList }: any) => {
  const medicaments = catalogList.filter((row) => row.subcategory === 'medicine');
  const services = catalogList.filter((row) => row.subcategory === 'service');
  const supplies = catalogList.filter((row) => row.subcategory === 'supply');
  const exams = catalogList.filter((row) => row.subcategory === 'exam');

  return (
    <View>
      {catalogList.length ? (
        <>
          <SkuSubcategoryTable catalog={exams} title="Exámenes" />
          <SkuSubcategoryTable catalog={services} title="Servicios" />
          <SkuSubcategoryTable catalog={medicaments} title="Medicamentos" />
          <SkuSubcategoryTable catalog={supplies} title="Suministros" />
        </>
      ) : (
        <EmptySkusState />
      )}
    </View>
  );
};

const RecordInfoBlock = ({ title, mapper, medicalRecord }: any) => {
  const isExist = mapper.some((row) => medicalRecord[row.name]);
  if (!isExist) return <></>;
  return (
    <View>
      <Text style={styles.blockTitle}>{title}</Text>
      <View style={styles.block}>
        {mapper.map((row) => (
          <View wrap={false} style={styles.blockItem} key={row.name}>
            {medicalRecord[row.name] ? (
              <>
                <Text>
                  <Text style={styles.blockItemTitleText}>{row.translationKey}:</Text>
                  {'     '} <Text style={styles.blockItemText}>{medicalRecord[row.name]}</Text>
                </Text>
              </>
            ) : (
              <></>
            )}
          </View>
        ))}
      </View>
    </View>
  );
};

const RecordInfo = ({ medicalRecord }: any) => {
  return (
    <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
      <RecordInfoBlock title="Signos vitales" mapper={vitalSigns} medicalRecord={medicalRecord} />
      <RecordInfoBlock title="Examenes de Laboratorio" mapper={laboratoryExams} medicalRecord={medicalRecord} />
      <RecordInfoBlock title="Examenes de Radiologia" mapper={radiologicalExams} medicalRecord={medicalRecord} />
      <RecordInfoBlock title="Diagnostico" mapper={diagnosis} medicalRecord={medicalRecord} />
      <RecordInfoBlock title="Tratamiento Clinico" mapper={clinicalTreatment} medicalRecord={medicalRecord} />
      <RecordInfoBlock title="Tratamiento Quirúrgico" mapper={surgicalTreatment} medicalRecord={medicalRecord} />
    </View>
  );
};

const RecordComments = ({ comments }: any) => {
  return (
    <View wrap={false}>
      <Text style={styles.sectionTitle}>Notas</Text>

      {comments &&
        comments.length &&
        [...comments].reverse()?.map((comment) => (
          <View style={styles.comment} key={comment.createdAt}>
            <Text style={styles.commentText}>{comment.comment}</Text>
            <Text style={styles.smallCommentText}>{format(comment.createdAt, 'dd.MM.yyyy')}</Text>
            <Text style={styles.smallCommentText}>{comment.commentedBy}</Text>
          </View>
        ))}
    </View>
  );
};

const MedicalRecordItem = ({ medicalRecord }: any) => {
  return (
    <View>
      <Text style={styles.medRecordTitle}>
        Record Medico {isValid(new Date(medicalRecord.name)) ? format(new Date(medicalRecord.name), 'dd.MM.yyyy') : medicalRecord.name}
      </Text>
      {medicalRecord?.catalog?.length ? <SkuTable catalogList={medicalRecord.catalog} /> : <></>}

      <RecordInfo medicalRecord={medicalRecord} />
      {!!medicalRecord.comments?.length && <RecordComments comments={medicalRecord.comments} />}
    </View>
  );
};

export const MedicalRecordPdf = memo(({ medicalRecord, patient }: any) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.logo} src={process.env.REACT_APP_ENV === 'master' ? prodLogo : logo} />

        <View>
          <Text style={styles.name}>
            {patient.firstName} {patient.lastName}
          </Text>
        </View>

        <MedicalRecordItem medicalRecord={medicalRecord} />

        {/* <View> */}
        <Text style={styles.signField} />
        <Text style={styles.signText}>(Firma del doctor)</Text>
        {/* </View> */}
      </Page>
    </Document>
  );
});
